import './style.scss'
import 'react-phone-input-2/lib/bootstrap.css'
import React, { useCallback } from 'react'
import ReactPhoneInput2 from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'

/**
 * @param {object} props
 * @param {string} props.id
 * @param {function} props.onChange
 * @param {string} [props.value]
 * @param {string} [props.containerClass]
 * @param {string} [props.country] By default it is 'es'
 * @param {string} [props.placeholder]
 * @param {boolean} [props.enableSearch] By default it is enabled
 * @param {boolean} [props.disabled]
 * @param {boolean} [props.onlyDialCode]
 *
 */
function PhoneInput(props) {
  const {
    id, onChange, containerClass, enableSearch = true,
    disabled, placeholder, onlyDialCode, country,
    value
  } = props

  let inputClass = ''
  if (onlyDialCode) inputClass += 'only_dial_code'

  const onChangeInput = useCallback((value, data) => {
    const { countryCode, name, dialCode } = data
    const response = {
      country: countryCode,
      countryName: name,
      dialCode: dialCode,
      phone: `${dialCode}${validatePhone(value, dialCode)}`,
      phoneValidate: validatePhone(value, dialCode)
    }

    if (onlyDialCode) {
      response.phone = response.dialCode
    }

    onChange(response)
  }, [onChange, onlyDialCode])

  const validatePhone = (value, dialCode) => {
    let phone = value.slice(dialCode.length)
    return phone.replace(/^[0]+/g, '')
  }

  return (
    <ReactPhoneInput2
      autoFormat
      id={id}
      localization={es}
      country={country || 'es'}
      containerClass={`phone_field_form ${containerClass || ''}`}
      buttonClass='phone_field_form_btn'
      inputClass={`phone_field_form_input ${inputClass}`}
      searchClass='phone_field_form_search'
      enableSearch={enableSearch}
      disabled={disabled || false}
      placeholder={placeholder || ''}
      value={value || '34'}
      onChange={onChangeInput}
    />
  )
}

export default PhoneInput